import { Toaster } from "sonner";

export function AppToaster() {
  return (
    <Toaster
      position="bottom-left"
      closeButton
      offset={16}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "sa-toast",
          title: "sa-toast__title",
          description: "sa-toast__description",
          actionButton: "sa-toast__action",
          cancelButton: "sa-toast__cancel",
          closeButton: "sa-toast__close",
          success: "sa-toast--success",
          error: "sa-toast--error",
          info: "sa-toast--info",
        },
      }}
    />
  );
}
